module.exports = (__webpack_require__(2))(50);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/FolderCollection.js from dll-reference girder_plugin_slicer_cli_web
// module id = 83
// module chunks = 0